import { RawRuleOf } from '@casl/ability';

import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { AppAbility } from '../../authz/types/app-ability';
import { BaseDto } from '../../base/dtos/base.dto';
import { UserRoleEnum } from '../enums/user-role.enum';
import { UserStatusEnum } from '../enums/user-status.enum';
import { UserTypeEnum } from '../enums/user-type.enum';

/**
 * User DTO for lists
 */
@CaslSubject(AppSubjectEnum.USER)
export class UserListDto extends BaseDto {
	username!: string;
	email!: string;
	status!: UserStatusEnum;
	type!: UserTypeEnum;
	userRoleName!: UserRoleEnum;
	userRolePermissions!: RawRuleOf<AppAbility>[];
	lastLoginAt?: Date;
	lastLoginIp?: string;

	mobileTitle = (): string => {
		return `${this.username}`;
	};

	mobileSubtitle = (): string => {
		return (
			`${this.userRoleName}` +
			`${this.lastLoginAt ? ` / ${this.lastLoginAt}` : ''}`
		);
	};
}
